import React, {Component} from 'react'
import PaperBlock from '../../ui/PaperBlock'

import BoxImage from "./BoxImage.png"

import {List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core'

/**
 * boxes - список коробок {id, code}.
 * selected - выбранная коробка.
 * onBoxClick(box) - сработает по клику на коробку.
 * onBoxDoubleClick(box) - двойной клик на коробку.
 */

class BoxesList extends Component {

    render() {
        let boxes = this.props["boxes"] ? this.props["boxes"] : []
        return <PaperBlock>
            <List>
                {boxes.map((box, n) => {
                    return <ListItem
                        key={n}
                        button
                        selected = {this.props.selected ? this.props.selected.id === box.id : false}
                        onClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onBoxClick === "function") {
                                this.props.onBoxClick(box)
                            }
                        }}
                        onDoubleClick={e => {
                            e.stopPropagation()
                            if (typeof this.props.onBoxDoubleClick === "function") {
                                this.props.onBoxDoubleClick(box)
                            }
                        }}
                    >
                        <ListItemIcon>
                            <img src={BoxImage} width={32} alt="show"/>
                        </ListItemIcon>
                        <ListItemText primary={box["code"]} />
                    </ListItem>
                })}
            </List>
        </PaperBlock>
    }

}

export default BoxesList